import { styled } from '@mui/material';
import MuiTab, { TabProps } from '@mui/material/Tab';
import ModulEnum from 'src/enums/ModulEnum';
import { useAppSelector } from 'src/store';
import { isVisible } from 'src/utils/formAuthHelper';

export interface ITabProps extends TabProps {
  authCode?: string;
  modul?: ModulEnum;
}
const CustomTab = styled(MuiTab)(({ theme }) => ({
  // height: 35,
  minHeight: 0,
  '&.Mui-selected': {
      backgroundColor: theme.palette.background.paper,
      marginLeft: 2,
      marginRight: 10,
      borderTopLeftRadius: 7,
      borderTopRightRadius: 7

  }
}));
const Tab = (props: ITabProps): JSX.Element => {
  const formSize = useAppSelector(s=> s.userLogin.formSize)
  return (isVisible(props.authCode, props.modul) && <CustomTab
    sx={{
      height: formSize * 3.5,
    }}
  {...props} />);
};

export default Tab;
